import cn from 'classnames';
import React, { memo, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import Button from '../../../../Button';
import CustomButtons from '../CustomButtons';
import RedirectToMozzazButton from '../RedirectToMozzazButton';

import { useIsMobile } from '../../../../../hooks/useIsMobile';
import { selectAppCustomButtons } from '../../../../../redux/data/selectors';

import styles from './index.styl';

const AppointmentListWrapper = ({
  actionText,
  additionalAction,
  buttonText,
  children,
  formatMessage,
  onClick,
  title,
}) => {
  const customButtons = useSelector(selectAppCustomButtons);

  const isMobile = useIsMobile();

  const getCareButton = useMemo(() => {
    return (
      <If condition={Boolean(buttonText)}>
        <Button
          raised
          color="primary"
          onClick={onClick}
          className={cn(styles.getCareButton, {
            [styles.mobileButton]: isMobile,
          })}
        >
          {buttonText}
        </Button>
      </If>
    );
  }, [customButtons, isMobile, buttonText, formatMessage]);

  const renderCustomButtonsRowItems = useMemo(() => {
    const buttons = customButtons.filter(button => !get(button, 'isInMenuBar'));

    if (!buttons.length) return null;

    return (
      <CustomButtons
        isMenuBar={false}
        customButtons={buttons}
        formatMessage={formatMessage}
        isFullWidthButton={isMobile}
      />
    );
  }, [customButtons, isMobile, formatMessage]);

  const renderCustomButtonsMenuItems = useMemo(() => {
    const isFullWidthButton = isMobile && !buttonText;

    const menuButtons = customButtons.filter(button =>
      get(button, 'isInMenuBar'),
    );

    if (!menuButtons.length) return null;

    return (
      <CustomButtons
        isMenuBar
        customButtons={menuButtons}
        formatMessage={formatMessage}
        isFullWidthButton={isFullWidthButton}
        additionalButtonStyles={cn({
          [styles.mobileCustomButtons]: isFullWidthButton,
        })}
      />
    );
  }, [customButtons, isMobile, buttonText, formatMessage]);

  const redirectToMozzazButton = useMemo(() => {
    return (
      <RedirectToMozzazButton
        btnTitle={formatMessage({ id: 'other.goToMozzaz' })}
      />
    );
  }, [formatMessage]);

  return (
    <div className={styles.root}>
      <If condition={!isMobile}>{renderCustomButtonsRowItems}</If>
      <div className={styles.header}>
        <If condition={isMobile}>
          <div className={styles.mobileButtonsSection}>
            {getCareButton}
            {renderCustomButtonsMenuItems}
          </div>
          <If condition={isMobile}>{renderCustomButtonsRowItems}</If>
        </If>
        <div className={styles.title}>
          <h3 className={styles.text}>{title}</h3>

          <div onClick={additionalAction} className={styles.link}>
            {actionText}
          </div>
        </div>
        <If condition={!isMobile}>
          <div className={styles.buttonsSection}>
            {redirectToMozzazButton}
            {getCareButton}
            {renderCustomButtonsMenuItems}
          </div>
        </If>

        <If condition={isMobile}>{redirectToMozzazButton}</If>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

AppointmentListWrapper.propTypes = {
  actionText: PropTypes.string,
  additionalAction: PropTypes.func,
  buttonText: PropTypes.string,
  children: PropTypes.node,
  formatMessage: PropTypes.func,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default memo(AppointmentListWrapper);



// WEBPACK FOOTER //
// ./src/components/Healthboard/HealthboardHome/components/AppointmentListWrapper/index.jsx